import PriceOfferTable from 'components/tables/data/price-offer/PriceOfferTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useDepartmentUiMode from 'model/useDepartmentUiMode';

/**
 * Page with the price offer table.
 */
export default function PriceOffersPage() {
  const { mode: departmentUiMode } = useDepartmentUiMode();
  const [searchParams, setSearchParams] = useSearchParams();

  const [initialFilters] = useState(() => {
    const filters: Record<string, any> = {};

    if (searchParams.has('deviceId')) {
      filters['device.deviceId'] = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('deviceId'),
      };
    }

    if (searchParams.has('departmentId')) {
      filters['department.departmentId'] = {
        mode: departmentUiMode === 'legacy' ? 'exact' : 'subtree',
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('departmentId'),
      };
    }

    if (searchParams.has('organizationId')) {
      filters['organization.organizationId'] = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('organizationId'),
      };
    }

    return filters;
  });

  useEffect(() => {
    setSearchParams(
      (params) => {
        params.delete('deviceId');
        params.delete('departmentId');
        params.delete('organizationId');
        return params;
      },
      { replace: true }
    );
  }, []);

  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Cenové ponuky' }]}>
      <PriceOfferTable initialFilters={initialFilters} />
    </DashboardLayout>
  );
}
